import _ from "lodash";
const areInCollision = (rdvA, rdvB) => {
    const [rdv1, rdv2] = _.sortBy([rdvA, rdvB], (a) => a.hour * 60 + a.minute);
    return !((beginsBeforeOrEqual(rdv1, rdv2) && endsBeforeOrEqual(rdv1, rdv2)) ||
        (beginsAfterBeginingOrEqual(rdv1, rdv2) &&
            beginsAfterEndOrEqual(rdv1, rdv2)));
};
const beginsBeforeOrEqual = (rdv1, rdv2) => rdv1.hour * 60 + rdv1.minute <= rdv2.hour * 60 + rdv2.minute;
const endsBeforeOrEqual = (rdv1, rdv2) => rdv1.hour * 60 + rdv1.minute + rdv1.duration <= rdv2.hour * 60 + rdv2.minute;
const beginsAfterBeginingOrEqual = (rdv1, rdv2) => rdv1.hour * 60 + rdv1.minute >= rdv2.hour * 60 + rdv2.minute;
const beginsAfterEndOrEqual = (rdv1, rdv2) => rdv1.hour * 60 + rdv1.minute >= rdv2.hour * 60 + rdv2.minute + rdv2.duration;
export default areInCollision;
//# sourceMappingURL=collision.js.map